import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import AnnouncementApi from "@/api/announcements-api";


@Module({ namespaced: true, name: 'announcements' })
export default class AnnouncementModule extends VuexModule {
  public announcements: AnnouncementDto[] = [];

  @Action({ commit: 'setAnnouncements' })
  async getAllAnnouncements(): Promise<AnnouncementDto[]> {
    const announcementApi = new AnnouncementApi();
    const announcements = await announcementApi.getAllAnnouncements();

    return announcements;
}

@Action
async createAnnouncementException(announcementId: string) {
    const announcementApi = new AnnouncementApi();

    try {
        await announcementApi.createAnnouncementException(announcementId);
        this.getAllAnnouncements();
    } catch(error) {
        console.error(error);
    }
}


// --- Mutations ---
@Mutation
public setAnnouncements(announcements: AnnouncementDto[]): void {
    this.announcements = announcements;
}

}
